import { Component, Input } from '@angular/core';

import { TournamentInterface } from '@interfaces/tournament.interface';

import { BaseComponent } from '../base.component';


@Component({
    selector: 'app-awards',
    templateUrl: './awards.component.html',
})
export class AwardsComponent extends BaseComponent {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input()
    public data: TournamentInterface | null;

    protected readonly console = console;

    public years: number[] = [];
    public selectedYear: number | null = null;

    public constructor(
    ) {
        super();
    }

    public get filteredAwards() {
        if (!this.selectedYear) {
            return this.data?.awards;
        }

        return this.data?.awards?.filter((a: any) => a.season.year === this.selectedYear);
    }


    ngOnChanges(): void {
        if (this.data?.awards) {
            const years = this.data.awards.map((a: any) => a.season.year);
            this.years = Array.from(new Set(years)).sort((a, b) => b - a);
            this.selectedYear = this.years[0] ?? null;
        }
    }


}
